// Third-party imports
import $ from 'jquery';
import _ from 'lodash';

// The global arg is expected to be the window object when run in a browser
export function initialize(global) {
    let shared = { index: 0 };

    $('form.cart').on('submit', event => {
        let form = $(event.target);
        if (!form.data('validated')) {
            event.preventDefault();
            checkTopupsBeforeSubmitting(shared, () => {
                form.data('validated', true);
                global.setTimeout(() => {
                    form.find('input[type="submit"]').click();
                });
            });
        }
    });
}

function checkTopupsBeforeSubmitting(shared, cb) {
    let topups = getTopups();
    topups = removeTopupsWithAmount(topups);
    topups = sortTopupsByLine(topups);
    removeNullTopupsFromBasket(shared, topups, cb);
}

function getTopups() {
    let topups = [];
    $('.basketCard[data-type-label="Sponsorship"] .js-amount').each(() => {
        topups.push({
            amount: parseFloat($(this).val()),
            line: $(this).data('line'),
        });
    });
    return topups;
}

function removeTopupsWithAmount(topups) {
    let revisedTopups = [];
    topups.forEach(topup => {
        if (topup.amount === 0) revisedTopups.push(topup);
    });
    return revisedTopups;
}

function sortTopupsByLine(topups) {
    return _.reverse(_.sortBy(topups, 'line'));
}

function removeNullTopupsFromBasket(shared, topups, cb) {
    let topup = topups[shared.index];
    if (topup) {
        $.post('/cart/change.js', { line: topup.line, quantity: 0 }, () => {
            shared.index++;
            removeNullTopupsFromBasket(topups, cb);
        });
    } else {
        cb();
    }
}
